import { IonButton } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import XLSX from "xlsx";
import { getEntries } from "../../../../services/users";
import {
  prepExportCCfrequency,
  prepExportFreqBites,
  prepExportIndependenceGraph,
  prepExportNWduration,
  prepExportNWfrequency,
  prepExportSleepOnset,
  prepExportVoidsGraph,
} from "../Charts/utils";

//https://github.com/SheetJS/sheetjs

interface props {
  users: any;
  id: any;
}

const DownloadData: React.FC<props> = ({ users, id }) => {
  const [user, setUser] = useState<any>({});
  const [sheetData, setSheetData] = useState<any>({});
  const [entries, setEntries] = useState<any>([]);

  // useEffect(()=>{
  //   console.log(sheetData)
  // },[sheetData]);

  useEffect(() => {
    if (users && users[id]) {
      setUser(users[id]);
    }
    //eslint-disable-next-line
  }, [users]);

  useEffect(() => {
    if (user && user.id) {
      getEntries(id).then((data: any) => {
        setEntries(data);
      });
    }

    //eslint-disable-next-line
  }, [user]);

  useEffect(() => {
    if (entries) {
      _setupData(id);
    }
    //eslint-disable-next-line
  }, [entries]);

  const exportFile = (data: any) => {
    /* convert state to workbook */
    //
    const wb = XLSX.utils.book_new();
    //console.log(data);
    Object.keys(data).forEach((el: any, idx: any) => {
      const ws = XLSX.utils.aoa_to_sheet(data[el]);
      XLSX.utils.book_append_sheet(wb, ws, el);
    });
    // Object.values(data).forEach((el: any, idx: any) => {
    // 	console.log(el);
    // 	const ws = XLSX.utils.aoa_to_sheet(el);
    // 	XLSX.utils.book_append_sheet(wb, ws, "Data");
    // });

    /* generate XLSX file and send to client */
    let TS = new Date().toISOString();
    XLSX.writeFile(wb, `${user.displayName}-${user.study}-${TS}.xlsx`);
  };

  const _setupDataEat = () => {
    let headers = [
      "Date",
      "Meal",
      "TF1 - Food",
      "TF1 - Amount Offered",
      "TF1 - Amount Consumed",
      "TF1 - Acceptance",
      "TF1 - Bites Consumed",
      "TF2 - Food",
      "TF2 - Amount Offered",
      "TF2 - Amount Consumed",
      "TF2 - Acceptance",
      "TF2 - Bites Consumed",
      "TF3 - Food",
      "TF3 - Amount Offered",
      "TF3 - Amount Consumed",
      "TF3 - Acceptance",
      "TF3 - Bites Consumed",
      "TF4 - Food",
      "TF4 - Amount Offered",
      "TF4 - Amount Consumed",
      "TF4 - Acceptance",
      "TF4 - Bites Consumed",
      "TF5 - Food",
      "TF5 - Amount Offered",
      "TF5 - Amount Consumed",
      "TF5 - Acceptance",
      "TF5 - Bites Consumed",
      "Behaviour",
      "Image Pre",
      "Image Post",
    ];

    let data = [headers];
    Object.values(entries).forEach((en: any, idx: any) => {
      let res = [];

      res.push(en.date, en.meal);

      let i = 0;
      while (i < 5) {
        let food = en.targetFood[i];
        if (food) {
          res.push(
            food.food,
            food.amountOfferedQTY,
            food.amountConsumedQTY,
            food.acceptance,
            food.numberBitesConsumed
          );
        } else {
          res.push("NA", "NA", "NA", "NA", "NA");
        }
        i++;
      }
      res.push(en.mealtimeBehaviour, en.imagePreURL, en.imagePostURL);
      data.push(res);
    });
    let freqBites = prepExportFreqBites(entries);
    setSheetData({
      ["raw"]: data,
      ["frequencyBites"]: freqBites,
    });
  };

  const _setupDataToilet = () => {
    let headers = [
      "Date",
      "Time",
      "Type",
      "Approach",
      "Level",
      "Training Day",
      "Stage",
      "Request",
      "Walking",
      "Undressing",
      "Sitting",
      "Duration",
      "Urination",
      "Defecation",
      "Did Not Void",
      "Wiping",
      "Dressing",
      "Flushing",
      "Accident Defecation",
      "Accident Urination",
      "Overnight Accident",
      "Number of Overnight Accidents",
      "Overnight Accident Defecation",
      "Overnight Accident Urination",
      "Night Nappy",
    ];

    let data = [headers];
    Object.values(entries).forEach((en: any, idx: any) => {
      let res = [];

      res.push(
        en.date,
        en.time,
        en.entryType,
        en.approach ? en.approach : "NA",
        en.level ? en.level : "NA",
        en.trainingDay ? en.trainingDay : "NA",
        en.stage ? en.stage : "NA",
        en.request ? en.request : "NA",
        en.walking ? en.walking : "NA",
        en.undressing ? en.undressing : "NA",
        en.sitting ? en.sitting : "NA",
        en.sittingDuration ? en.sittingDuration : "NA",
        en.urination !== "" ? en.urination : "NA",
        en.defecation !== "" ? en.defecation : "NA",
        en.didNotVoid !== "" ? en.didNotVoid : "NA",
        en.wiping ? en.wiping : "NA",
        en.flushing ? en.flushing : "NA",
        en.dressing ? en.dressing : "NA",
        en.accidentDefecation !== "" ? en.accidentDefecation : "NA",
        en.accidentUrination !== "" ? en.accidentUrination : "NA",
        en.overnightAccident ? en.overnightAccident : "NA",
        en.numONAccidents,
        en.ONaccidentDefecation !== "" ? en.ONaccidentDefecation : "NA",
        en.ONaccidentUrination !== "" ? en.ONaccidentUrination : "NA",
        en.nightNappy !== "" ? en.nightNappy : "NA"
      );

      data.push(res);
    });
    let independence = prepExportIndependenceGraph(entries);
    let voids = prepExportVoidsGraph(entries);
    setSheetData({
      ["raw"]: data,
      ["independence"]: independence,
      ["voids"]: voids,
    });
  };

  const _getList = (field: any) => {
    let list = "NA";
    Object.entries(field)
      .filter((e: any) => e[1])
      .forEach((el: any) => {
        //console.log(el[0]);
        if (list == "NA" && el[0]) {
          list = el[0];
        } else if (el[0] === "otherDescribe") {
          // do nothing
        } else {
          list = list.concat(", ", el[0]);
        }
      });
    return list;
  };

  const _setupDataSleep = () => {
    //console.log(entries);

    let headers = [
      "Date",
      "Entry Complete",
      "Unwell",
      "Medication",
      "Day Sleeps",
      "Number DS",
      "DS 1 - Setting",
      "DS 1 - Setting - Other",
      "DS 1 - Time Asleep",
      "DS 1 - Time Awake",
      "DS 2 - Setting",
      "DS 2 - Setting - Other",
      "DS 2 - Time Asleep",
      "DS 2 - Time Awake",
      "DS 3 - Setting",
      "DS 3 - Setting - Other",
      "DS 3 - Time Asleep",
      "DS 3 - Time Awake",
      "DS 4 - Setting",
      "DS 4 - Setting - Other",
      "DS 4 - Time Asleep",
      "DS 4 - Time Awake",
      "DS 5 - Setting",
      "DS 5 - Setting - Other",
      "DS 5 - Time Asleep",
      "DS 5 - Time Awake",
      "DS 6 - Setting",
      "DS 6 - Setting - Other",
      "DS 6 - Time Asleep",
      "DS 6 - Time Awake",
      "Night Setting",
      "Night Setting - Other",
      "Night time to bed",
      "Night time asleep",
      "Present at onset",
      "Present Hours",
      "Present Mins",
      "Present All Night",
      "Curtain calls",
      "Number CC",
      "CC Behaviour",
      "CC Behaviour Other",
      "CC Response",
      "CC Response Other",
      "CC Notes",
      "Co-sleeping",
      "Co-sleeping duration Hours",
      "Co-sleeping duration Minutes",
      "Night Wakings",
      "Number NW",
      "NW 1 - Awake",
      "NW 1 - Duration",
      "NW 2 - Awake",
      "NW 2 - Duration",
      "NW 3 - Awake",
      "NW 3 - Duration",
      "NW 4 - Awake",
      "NW 4 - Duration",
      "NW 5 - Awake",
      "NW 5 - Duration",
      "NW 6 - Awake",
      "NW 6 - Duration",
      "NW 7 - Awake",
      "NW 7 - Duration",
      "NW 8 - Awake",
      "NW 8 - Duration",
      "NW 9 - Awake",
      "NW 9 - Duration",
      "NW 10 - Awake",
      "NW 10 - Duration",
      "NW Behaviours",
      "NW Behaviours Other",
      "NW Responses",
      "NW Responses Other",
      "NW Notes",
      "Early Waking",
      "EW Behaviours",
      "EW Behaviours Other",
      "EW Responses",
      "EW Responses Other",
      "EW Notes",
      "Morning Waking Time",
      "Other Notes",
    ];

    let data = [headers];

    Object.values(entries).forEach((en: any, idx: any) => {
      //excludes duplicate sleep entries with no date that can occur somehow
      if (en.date) {
        //day sleeps
        let DSresult = [];
        let i = 0;
        while (i < 6) {
          let DS = en.daySleeps[idx];
          if (DS) {
            DSresult.push(
              DS.DSsetting,
              DS.DSother ? DS.DSother : "NA",
              DS.DStimeAsleep,
              DS.DStimeAwake
            );
          } else {
            DSresult.push("NA", "NA", "NA", "NA");
          }
          i++;
        }

        //NWs timeAwake, duration
        let NWresult = [];
        let NWi = 0;
        while (NWi < 10) {
          let NW = en.nightWakings[NWi];
          if (NW) {
            NWresult.push(NW.NWtimeAwake, NW.NWduration);
          } else {
            NWresult.push("NA", "NA");
          }
          NWi++;
        }

        let res = [];

        res.push(
          en.date,
          en.complete ? "YES" : "NO",
          en.unwell ? "YES" : "NO",
          en.medication,
          en.didDaySleep ? "YES" : "NO",
          en.numDaySleeps,
          ...DSresult,
          en.settingNight,
          en.otherNight ? en.otherNight : "NA",
          en.timeBed,
          en.timeAsleep,
          en.presentAtOnset ? "YES" : "NO",
          en.presentHours,
          en.presentMins,
          en.presentAllNight ? "YES" : "NO",
          en.curtainCalls ? "YES" : "NO",
          en.numCurtainCalls,
          _getList(en.ccActivity),
          en.ccActivity.otherDescribe ? en.ccActivity.otherDescribe : "",
          _getList(en.ccResponse),
          en.ccResponse.otherDescribe ? en.ccResponse.otherDescribe : "",
          en.ccNotes,
          en.cosleep ? "YES" : "NO",
          en.cosleepLengthHours,
          en.cosleepLengthMins,
          en.didNightWakings ? "YES" : "NO",
          en.numNightWakings,
          ...NWresult,
          _getList(en.NWBehaviour),
          en.NWBehaviour.otherDescribe ? en.NWBehaviour.otherDescribe : "",
          _getList(en.NWResponse),
          en.NWResponse.otherDescribe ? en.NWResponse.otherDescribe : "",
          en.NWNotes,
          en.earlyWaking ? "YES" : "NO",
          _getList(en.EWBehaviour),
          en.EWBehaviour.otherDescribe ? en.EWBehaviour.otherDescribe : "",
          _getList(en.EWResponse),
          en.EWResponse.otherDescribe ? en.EWResponse.otherDescribe : "",
          en.EWNotes,
          en.MWTime,
          en.additionalNotes
        );

        data.push(res);
      }
    });
    let SO = prepExportSleepOnset(entries);
    let CC = prepExportCCfrequency(entries);
    let NW = prepExportNWfrequency(entries);
    let NWDur = prepExportNWduration(entries);
    setSheetData({
      ["raw"]: data,
      ["sleepOnsetLatency"]: SO,
      ["FrequencyCC"]: CC,
      ["FrequencyNW"]: NW,
      ["DurationNW"]: NWDur,
    });
  };

  const _setupData = (uid: any) => {
    if (user.study === "eat") _setupDataEat();
    else if (user.study === "toilet") _setupDataToilet();
    else if (user.study === "sleep") _setupDataSleep();
  };

  return <IonButton onClick={() => exportFile(sheetData)}>Download</IonButton>;
};

const mapStateToProps = (state: any) => ({
  users: state.user.users,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadData);
